import React, { useState } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { Link } from 'react-router-dom'
import ReactQuill from 'react-quill';
import { useDropzone } from 'react-dropzone'
import { IconCloudUpload, IconFileTypePdf } from '@tabler/icons-react';

export default function AddProject() {

    const [image, setImage] = useState({ file: '', name: '' });
    const onDrop = acceptedFiles => {
        const file = acceptedFiles[0];
        setImage({ file, name: file.name });
    };
    const { getRootProps: getRootPropsImage, getInputProps: getInputPropsImage } = useDropzone({ onDrop, accept: { 'image/*': [], 'application/pdf': [] } });

    var toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],

        ['blockquote', 'code-block'],

        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],

        [{ 'align': [] }],

        [{ 'list': 'ordered' }, { 'list': 'bullet' }],

        ['link', 'image'],

        [{ 'script': 'sub' }, { 'script': 'super' }],
    ];

    return (
        <>
            <Breadcrumb title="Add Project" path="Projects / Add Project" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='grid md:grid-cols-12 gap-15'>
                    <div className='form-group col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Project Name</label>
                        <input type='text' id='projectName' name='projectName' placeholder='Project Name*' />
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Select Client Name</label>
                        <select name="selectClientName" id="selectClientName">
                            <option>-- Select Client Name --</option>
                            <option>Core Technolab Pvt.</option>
                            <option>vPro Infoweb LLC.</option>
                            <option>M2 Solution Pvt. Ltd.</option>
                        </select>
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Start Date</label>
                        <div className='flex'>
                            <input type='date' id='startDate' name='startDate' placeholder='startDate' className='grow' />
                        </div>
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>End Date</label>
                        <div className='flex'>
                            <input type='date' id='endDate' name='endDate' placeholder='endDate' className='grow' />
                        </div>
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Select Project Priority</label>
                        <select name="selectProjectPriority" id="selectProjectPriority">
                            <option>-- Select Project Priority --</option>
                            <option>High</option>
                            <option>Medium</option>
                            <option>Low</option>
                        </select>
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Rate In Dollar</label>
                        <input type='number' id='rateInDollar' name='rateInDollar' placeholder='Rate In Dollar*' />
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Select Rate Type</label>
                        <select name="selectRateType" id="selectRateType">
                            <option>-- Select Rate Type --</option>
                            <option>Hourly</option>
                            <option>Fixed</option>
                        </select>
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Select Team Lead</label>
                        <select name="selectTeamLead" id="selectTeamLead">
                            <option>-- Select Team Lead --</option>
                            <option>Marshall Nichols</option>
                            <option>Susie Willis</option>
                            <option>Hossein Shams</option>
                            <option>Fidel Tonn</option>
                            <option>Frank Camly</option>
                            <option>Debra Stewart</option>
                            <option>Tim Hank</option>
                        </select>
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Select Team</label>
                        <select name="selectTeam" id="selectTeam">
                            <option>-- Select Team --</option>
                            <option>Team A</option>
                            <option>Team B</option>
                            <option>Team C</option>
                            <option>Team D</option>
                            <option>Team E</option>
                        </select>
                    </div>
                    <div className='col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Project Image</label>
                        <div {...getRootPropsImage()} className='custom-dropzone cursor-pointer border-2 border-border p-10 relative h-[200px] text-center flex items-center justify-center bg-bg-light'>
                            <input {...getInputPropsImage()} />
                            {image.file ? (
                                <div className="absolute w-full h-full top-0 left-0 right-0 bottom-0 text-center p-10 bg-bg-light group">
                                    {image.file.type === 'application/pdf' ? (
                                        <div className='w-full h-full flex flex-col gap-5 justify-center items-center relative'>
                                            <IconFileTypePdf className='w-[40px] h-[40px] text-text-secondary' />
                                        </div>
                                    ) : (
                                        <img src={URL.createObjectURL(image.file)} alt="Uploaded" className='relative top-[50%] translate-y-[-50%] max-w-full max-h-full mx-auto' />
                                    )}
                                    <div className='absolute left-0 top-0 right-0 bottom-0 bg-slate-950/70 text-text-secondary flex flex-col gap-15 items-center justify-center opacity-0 transition-opacity duration-150 ease-linear group-hover:opacity-100'>
                                        <p className='text-white font-medium truncate max-w-[200px]'>
                                            {image.name}
                                        </p>
                                        <span className='inline-block w-30 h-[2px] bg-border'></span>
                                        <p>
                                            Drag and drop or click to replace
                                        </p>
                                    </div>
                                </div>
                            )
                                :
                                <p className='text-text-secondary flex flex-col gap-5 justify-center items-center relative'>
                                    <IconCloudUpload className='w-[50px] h-[50px] stroke-[1]' />
                                    Drag and drop a file here or click
                                </p>
                            }
                        </div>
                    </div>
                    <div className='col-span-12'>
                        <label className='font-medium mb-5 inline-block'>Project Description</label>
                        <ReactQuill
                            modules={{ toolbar: toolbarOptions }}
                            className='bg-bg-light'
                            defaultValue="
                                <p>
                                Hello There !
                                </p>
                                <p>
                                The toolbar can be customized and it also supports various callbacks such as 
                                <span style='color: red;'>oninit</span>, 
                                <span style='color: red;'>onfocus</span>, 
                                <span style='color: red;'>onpaste</span> 
                                and many more.
                                </p>
                                <br/>
                                <p>
                                Please try 
                                <b>paste some texts</b>
                                here
                                </p>
                            "
                        />
                    </div>
                    <div className='col-span-12 flex flex-wrap gap-10'>
                        <button className='btn btn-primary'>
                            Create
                        </button>
                        <Link to="/app-inbox" className='btn btn-outline-secondary'>
                            Cancel
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
